<template>
  <div class="flex max-w-full">
    <svg
      class="shrink-0 text-[#e3f77e]"
      height="24"
      width="5"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 0H3.2C2.1 0 1.5 0 1.1.2a2 2 0 0 0-.9.9C0 1.5 0 2 0 3.2v4.9l.2.2.6.2c1.7.3 3 1.8 3 3.5s-1.3 3.2-3 3.5l-.6.2-.2.2v4.9c0 1.1 0 1.7.2 2.1.2.4.5.7.9.9.4.2 1 .2 2.1.2H5V0Z"
        fill="currentColor"
      />
    </svg>
    <div class="bg-static-info-max body-2-bold flex h-24 min-w-0 items-center">
      <component :is="icon" v-if="icon" class="w-16 shrink-0" />
      <BouncingContent class="-ml-2">
        {{ label }}
      </BouncingContent>
      <RevTooltip v-if="tooltipText" alignment="left">
        <template #trigger="{ show, hide }">
          <IconInfo
            size="16"
            @focusin="show"
            @focusout="hide"
            @mouseleave="hide"
            @mouseover="show"
          />
        </template>
        {{ tooltipText }}
      </RevTooltip>
    </div>
    <svg
      class="shrink-0 text-[#e3f77e]"
      height="24"
      width="5"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0h1.8c1.1 0 1.7 0 2.1.2.4.2.7.5.9.9.2.4.2 1 .2 2.1v4.9l-.2.2-.6.2c-1.7.3-3 1.8-3 3.5s1.3 3.2 3 3.5l.6.2.2.2v4.9c0 1.1 0 1.7-.2 2.1a2 2 0 0 1-.9.9c-.4.2-1 .2-2.1.2H0V0Z"
        fill="currentColor"
      />
    </svg>
  </div>
</template>

<script lang="ts" setup>
import type { Component } from 'vue'

import { RevTooltip } from '@ds/components/Tooltip'
import { IconInfo } from '@ds/icons/IconInfo'

import BouncingContent from '../BouncingContent.vue'

defineProps<{
  label: string
  icon?: Component
  tooltipText?: string
}>()
</script>
